require('./loginView.scss');
const React = require('react');
const { Component, Fragment } = require('react');

const { LoadingSection } = require('commonsComponents/loadingSection');
const { LoginForm } = require('components/loginForm/loginForm.js');

import WebappRender from 'components/conditionalRender/webappRender';
import ContactCenterRender from 'components/conditionalRender/contactCenterRender';
import CountrySelector from './countrySelector/countrySelector.js';

class LoginView extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleChange = (countryOptions) => {
        this.setState({
            'originCountry': countryOptions.value
        });
    }

    render() {
        /**
         * (andres): The login sidebar only slides in when the user navigates to /login.
         * If the user closes the sidebar and then clicks the "login" button again, it doens't
         * slide in back, since the state is not changed and nothing is re-rendered.
         * By sending a random attribute (which is not being used anywhere else, so it doesn't
         * matter neither the name nor the value, as long as it is random) we force the
         * <LoginForm> componente to be re-rendered and the sidebar slides back in.
         */

        const ramdomValue = Math.random().toString();
        const { originCountry } = this.state
        return (
            <Fragment>
                <WebappRender>
                    <div className="login-view" id="secLoginView">
                        <div style={{ fontSize: 18 + 'px', float: 'left', margin: 50 + 'px', marginTop: 120 + 'px' }}>
                            <p>    Esta pantalla solo existe en ambiente de desarrollo para poder loguearse. </p>
                            <ul>
                                <li>Nunca se va a estar deslogueado en el sitio privado</li>
                                <li>El componente de login solo existe en el sitio publico</li>
                                <li>La topbar puede funcionar distinto al sitio publico estando deslogueado</li>
                            </ul>

                            <b>
                                Selecciona el país:
                            </b>

                            <CountrySelector
                                onHandleChange={this.handleChange}
                                selectedCountry={originCountry}
                            />

                        </div>
                        <LoginForm
                            r={ramdomValue}
                            originCountry={originCountry}
                        />
                    </div>
                </WebappRender>
                <ContactCenterRender>
                    <div>
                        <LoadingSection />
                        <LoginForm
                            r={ramdomValue}
                            {...this.props}
                        />
                    </div>
                </ContactCenterRender>
            </Fragment>

        );
    }
}

module.exports = LoginView;
